import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';
import { NgClass, NgFor } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';

import { VexDateFormatRelativePipe } from '@vex/pipes/vex-date-format-relative/vex-date-format-relative.pipe';
import { trackById } from '@vex/utils/track-by';

import { Notification } from '../interfaces/notification.interface';
import { GlobalService } from '../../../../../shared/services/global.service';
import { AuthService } from '../../../../../shared/services/auth.service';
import { VexPopoverRef } from '@vex/components/vex-popover/vex-popover-ref';
import { ChimeService } from '../../../../../shared/services/chime.service';

@Component({
  selector: 'vex-toolbar-notifications-dropdown',
  templateUrl: './toolbar-notifications-dropdown.component.html',
  styleUrls: ['./toolbar-notifications-dropdown.component.scss'],
  standalone: true,
  imports: [
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    NgFor,
    MatRippleModule,
    RouterLink,
    NgClass,
    VexDateFormatRelativePipe
  ],
  providers: [GlobalService, AuthService]
})
export class ToolbarNotificationsDropdownComponent implements OnInit {
  notifications: Notification[] = [];
  notificationCount: number = 0;

  constructor(
    private cd: ChangeDetectorRef,
    private chimeService: ChimeService
  ) {
    const popoverRef = inject(VexPopoverRef<any>);
    this.notifications = popoverRef.data?.notifications || [];
  }

  ngOnInit(): void {
    this.notificationCount = this.notifications.filter(n => !n.read).length;
    this.cd.markForCheck();
  }

  markAllAsRead(): void {
    this.notifications = [];
    this.notificationCount = this.notifications.length;
    this.chimeService.updateSubjectValue(true);
  }

  trackById = trackById;
}
